import svg from './row-svg/espace-documentaire.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EspaceDocumentaireIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default EspaceDocumentaireIcon;
